import { createContext } from "react";

import type { GlobalConfig } from "@clinic/shared/data/globals/DefaultGlobals";
import { DefaultGlobals } from "@clinic/shared/data/globals/DefaultGlobals";

const GlobalContext = createContext<GlobalConfig>(DefaultGlobals);

export { GlobalContext };
